import * as Types from '../types/Verify';

export const verifyRouteAction = (params) => ({type: Types.VERIFY_ROUTE_ACTION, params});
export const verifyRouteSuccess = (data) => ({type: Types.VERIFY_ROUTE_SUCCESS, data});

export const verifyInit = (params) => ({type: Types.VERIFY_INIT, params});
export const verifyFail = (params) => ({type: Types.VERIFY_FAILED, params});
